module.exports = __webpack_public_path__ + "static/img/asan-hospital.4d9ee86.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/partner/asan-hospital.gif
// module id = i2Sl
// module chunks = 0